<!-- password-strength.component.html -->

<div class="password-strength-container">
    <!-- Password Strength Bars -->
    <div class="password-bar" [style.background]="bar0"></div>
    <div class="password-bar" [style.background]="bar1"></div>
    <div class="password-bar" [style.background]="bar2"></div>
    <div class="password-bar" [style.background]="bar3"></div>
</div>
  